import React from 'react';
import PropTypes from 'prop-types';
import {Form} from '@evag/ec-react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import CustomHero from 'src/components/CustomHero';
import Peticao from 'src/components/forms/parts/Peticao';
import OAB from 'src/components/forms/parts/OAB';
import Feedback from '../components/forms/parts/Feedback';

import styles from './cassacao.module.scss';
import a from '../components/Article.module.scss';

const title = "Lula livre, e agora? Desafios da esquerda socialista no Brasil."
const channelId = "fae7da17-ed2f-4e0b-ac60-50c57cf36160"

export default function render({data, location}) {
  return (
    <Layout solidHeader={true}>
      <SEO
        title={title}
        description="Faça já sua inscrição e participe do debate com Luciana Genro, Sâmia Bomfim e Erika Hilton."
        ogimage={{
          src:
            'https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/convocatoria.jpg',
          width: '1200',
          height: '600',
        }}
      />

      <CustomHero
        image={{
          alt: title,
          src:
            'https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/fundo_convocatoria.jpg',
        }}
        overClassName={styles.over}
      >
        <img
          style={{display: 'block', margin: 'auto'}}
          src="https://cdn.samiabomfim.com.br/wp-content/uploads/2021/03/texto_convocatoria.png"
        />
      </CustomHero>

      <div className={styles.form}>
        <div className={a.wrap}>
        <p>
              
              Para discutir os desafios da esquerda brasileira a partir da habilitação de Lula para concorrer à presidência, convidamos você para um debate com Luciana Genro, Sâmia Bomfim e Erika Hilton. 

              </p>
              <br/>
        <p>
        A atividade será realizada pelo Zoom no dia 5/4, às 19h. Para participar, basta preencher o formulário de inscrição a seguir.
              </p>

          <Form
            forms={[
              {
                ...Peticao,
                channelId,
                showFiliado: true,
                btnText: 'Inscrever',
              },
              {
                ...Feedback,
                url: location.href,
                text:
                  'Muito obrigada! Agora ajude a espalhar compartilhando nas redes sociais.',
              },
            ]}
          />
        </div>
      </div>
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};
